// window._ = require('lodash');

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['Accept'] = 'application/json';

const csrf = document.head.querySelector('meta[name="csrf-token"]');
if (csrf) {
	window.axios.defaults.headers.common['X-CSRF-TOKEN'] = csrf.content;
}
